import type { JSX } from 'react';
import { Navigate, useParams } from 'react-router';

import TestingCenterLayout from './TestingCenterLayout';

const TestingCenterPage = (): JSX.Element => {
  const { masterProjectId } = useParams<{ masterProjectId: string }>();
  const id = Number(masterProjectId);

  if (!masterProjectId || Number.isNaN(id)) {
    return <Navigate to="/project" replace />;
  }

  return <TestingCenterLayout masterProjectId={id} />;
};

export default TestingCenterPage;
